import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { StreamSkeletonComponent } from '@app/modules/stream/components/stream-skeleton/stream-skeleton.component';
import { SkeletonModule } from '@app/modules/ui/skeleton/skeleton.module';
import { SharedModule } from '@app/shared/shared.module';
import { StreamPageComponent } from '@app/modules/stream/components/stream-page/stream-page.component';
import { NotificationStreamItemComponent } from '@app/modules/stream/components/notification-stream-item/notification-stream-item.component';
import { AchievementStreamItemComponent } from '@app/modules/stream/components/achievement-stream-item/achievement-stream-item.component';
import { AvatarModule } from '@app/modules/ui/avatar/avatar.module';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
  imports: [AvatarModule, SharedModule, SkeletonModule, UIRouterModule],
  declarations: [
    AchievementStreamItemComponent,
    NotificationStreamItemComponent,
    StreamPageComponent,
    StreamSkeletonComponent
  ],
  exports: [StreamPageComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class StreamModule {}
